import { BlogIndexPage } from 'components/blog/blog-index-page';
import { BlogWrapper } from 'components/blog/blog-wrapper';
import { fetchArticles } from 'queries';

const IndexRoute = ({ ssr, router, session, store, toast }) => {
	// Render
	return <BlogIndexPage title='Latest from Playbooks' ssr={ssr} />;
};

IndexRoute.getLayout = page => <BlogWrapper seo={{ title: 'Playbooks Blog | All' }}>{page}</BlogWrapper>;

export async function getServerSideProps({ params, query }) {
	const articles = await fetchArticles({ params, query });
	return { props: { articles } };
}

export default IndexRoute;
